import { PageUserData } from 'src/editor/shared/types/page-user-data'
import { UserDataApiInterface } from 'src/shared/types/user-data-api-interface'

export const convertUserDataToPageUserData = (
  userData: UserDataApiInterface,
): PageUserData => {
  // NOTE: there is no isFreemium property in the UserDataApiInterface, so we skip it
  return {
    email: userData.mainUser.user.email,
    name: `${userData.firstName} ${userData.lastName}`,
    id: userData.id,
    timezone: userData.timezone,
    isAdmin: userData.roles.includes('ROLE_ADMIN'),
    dashboardLocale: userData.dashboardLocale,
    impersonator: userData.impersonator,
  }
}
